/**
 * 邮件推送相关 API (从公共库同步)
 */
export default {
  name: 'emailPush',
  // 邮件传播
  GetMagByPlatMagId: {
    url: '/das-api/vas/mag/getMagByPlatMagId'
  },
  GetPushTaskList: {
    url: '/das-api/vas/push/task/pushTaskList'
  },
  GetTaskInfo: {
    url: '/das-api/vas/push/task/getTaskInfo'
  },
  GetAuthorRankList: {
    url: '/das-api/vas/push/task/authorRankList'
  },
  GetDiffusePathList: {
    url: '/das-api/vas/push/task/diffusePath'
  },
  GetStatisticsByDay: {
    url: '/das-api/vas/push/task/statisticsByDay'
  },
  GetAllTaskInfo: {
    url: '/das-api/vas/push/task/getAllTaskInfo'
  },
  GetMagDetail: {
    url: '/das-api/vas/mag/get'
  },
  // 邮件推送-报告部分
  GetPushArticleSumVisitCount: {
    url: '/das-api/vas/article/statistics/getPushArticleSumVisitCount'
  },
  GetActivatedOrg: {
    url: '/das-api/vas/send/author/getActivatedOrg'
  },
  GetPushArticleVisitCount: {
    url: '/das-api/vas/article/statistics/getPushArticleVisitCount'
  },
  GetArticleClickList: {
    url: '/das-api/vas/push/task/articleClickRankList'
  },
  GetArticleOfficialClickList: {
    url: '/das-api/vas/push/task/articleOfficialClickRankList'
  },
  GetReadArticleOrg: {
    url: '/das-api/vas/send/author/getReadArticleOrg'
  },
  GetReadArticleMag: {
    url: '/das-api/vas/send/author/getReadArticleMag'
  },
  GetOpenEmailOrg: {
    url: '/das-api/vas/send/author/getOpenEmailOrg'
  },
  GetOpenEmailMag: {
    url: '/das-api/vas/send/author/getOpenEmailMag'
  },
  GetSum: {
    url: '/das-api/vas/send/author/getSum'
  },
  GetSourceType: {
    url: '/das-api/vas/send/author/getSourceType'
  },
  GetPushMagAuthorOrg: {
    url: '/das-api/vas/send/author/getOrg'
  },
  GetMag: {
    url: '/das-api/vas/send/author/getMag'
  },
  GetSumWhiteListAuthor: {
    url: '/das-api/vas/send/author/getSumWhiteListAuthor'
  },
  GetWhiteListAuthorSumList: {
    url: '/das-api/vas/send/author/getWhiteListAuthorSumList'
  },
  ReferenceMag: {
    url: '/das-api/vas/statistics/referenceMag'
  },
  CitationMag: {
    url: '/das-api/vas/statistics/citationMag'
  },
  CitationMagV2: {
    url: '/das-api/vas/statistics/citationV2'
  },
  ReferenceInstitution: {
    url: '/das-api/vas/statistics/referenceInstitution'
  },
  CitationInstitution: {
    url: '/das-api/vas/statistics/citationInstitution'
  },
  CitationInstitutionV2: {
    url: '/das-api/vas/statistics/citationInstitutionV2'
  },
  Institution: {
    url: '/das-api/vas/statistics/institution'
  },
  GetAuthorSumList: {
    url: '/das-api/vas/send/author/getAuthorSumList'
  },
  GetKeywordsStatistics: {
    url: '/das-api/vas/statistics/getKeywordsStatistics'
  },
  GetCoocwordsStatistics: {
    url: '/das-api/vas/statistics/getCoocwordsStatistics'
  },
  ZxsMag: {
    url: '/das-api/vas/statistics/zxsMag'
  },
  ZxsInstitution: {
    url: '/das-api/vas/statistics/zxsInstitution'
  },
  GetPushStatus: {
    url: '/das-api/vas/push/task/getPushStatus'
  },
  GetIssueArticleCitation: {
    url: '/das-api/vas/article/getIssueArticleCitation'
  },
  SumIssueArticleCitation: {
    url: '/das-api/vas/article/sumIssueArticleCitation'
  },
  GetCountRootArticleCitations: {
    url: '/das-api/vas/article/countRootArticleCitations'
  },
  GetCountMagCitations: {
    url: '/das-api/vas/article/countMagCitations'
  },
  GetCountRootMagOrg: {
    url: '/das-api/vas/article/countRootMagOrg'
  },
  GetCountCitationsMagOrg: {
    url: '/das-api/vas/article/countCitationsMagOrg'
  },
  GetCountRootArticleKeywords: {
    url: '/das-api/vas/article/countRootArticleKeywords'
  },
  GetCountCitatinsArticleKeywords: {
    url: '/das-api/vas/article/countCitatinsArticleKeywords'
  },
  getWechatPicAddress: {
    url: '/das-api/vas/wechat/wechatPicAddress'
  }
}

